// @flow
import { Record } from "immutable";

export type ReviewActionRecordI = {
  id: string,
  eventId: string,
  actionType: string,
  actorUserId: string,
  actionNote: ?string,
  createdAt: string,
  set: (key: string, value: mixed) => ReviewActionRecordI,
  toJS: () => { [string]: mixed },
};

const ReviewActionRecord = Record({
  id: "",
  eventId: "",
  actionType: "",
  actorUserId: "",
  actionNote: null,
  createdAt: "",
});

export default ReviewActionRecord;
